import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { Aprendiz } from "@interfaces/user.interface";

interface Props {
  data: Aprendiz;
}

export function DetalleAprendiz({ data }: Props) {
  const { ultimaActividad, creadoEl, actualizadoEl, usuario } = data;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Información del Aprendiz</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <strong>Ultima actividad:</strong> {ultimaActividad}
        </div>
        <div>
          <strong>Creado el:</strong> {new Date(creadoEl).toLocaleDateString()}
        </div>
        <div>
          <strong>Actualizado el:</strong>{" "}
          {new Date(actualizadoEl).toLocaleDateString()}
        </div>

        <div className="border-t pt-4">
          <strong>Usuario Responsable:</strong>
          <div className="mt-2 space-y-1 ml-2">
            <div>
              <strong>Nombre:</strong> {usuario.nombre}{" "}
              {usuario.apellidoPaterno} {usuario.apellidoMaterno ?? ""}
            </div>
            <div>
              <strong>Correo:</strong> {usuario.correo}
            </div>
            <div>
              <strong>Rol:</strong> {usuario.rol?.nombre}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
